module.exports = "../study/imgs/maps/Kanagawa/S8/Ecosystem/Qacuta/Kanagawa_Qacuta_HadGEM2_RCP45_Mid.png";